"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountsForm = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _theme = require("../../theme");

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _basis = require("basis");

var _Form = require("../form/Form");

var _FormLayout = require("../form-layout/FormLayout");

var _SubmitButton = require("../submit-button/SubmitButton");

var _ = require("./..");

var _hooks = require("../../hooks");

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var OptionLabel = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  & > *:last-child {\n    align-self: end;\n  }\n  & strong {\n    font-weight: ", " !important;\n  }\n"])), function (p) {
  return p.theme.media.min.xs(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    display: grid;\n    grid-template-columns: 1fr auto;\n  "])));
}, function (p) {
  return p.theme.basis.fontWeights.semiBold;
});

var s = {
  OptionLabel: OptionLabel
};

var accountsToOptions = function accountsToOptions(accounts, content, highlightColor) {
  return accounts.map(function (item) {
    return {
      label: /*#__PURE__*/_react.default.createElement(s.OptionLabel, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_basis.Text, {
        margin: "0 0 2 0"
      }, /*#__PURE__*/_react.default.createElement(_basis.VisuallyHidden, null, content.a11yTextAccountName), /*#__PURE__*/_react.default.createElement("strong", null, item.name)), /*#__PURE__*/_react.default.createElement(_basis.Text, {
        margin: "0 0 2 0",
        "margin-xs": "0"
      }, /*#__PURE__*/_react.default.createElement(_basis.VisuallyHidden, null, content.a11yTextAccountNumber), item.accountNumber)), /*#__PURE__*/_react.default.createElement(_basis.Text, {
        color: highlightColor
      }, /*#__PURE__*/_react.default.createElement(_basis.VisuallyHidden, null, content.a11yTextAvailableBalance), /*#__PURE__*/_react.default.createElement("strong", null, "$".concat(item.available)))),
      key: item.id.toString()
    };
  });
};

var AccountsForm = function AccountsForm(props) {
  var data = props.data,
      onSelectAccounts = props.onSelectAccounts,
      loading = props.loading;
  var content = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.content.accounts;
  });
  var theme = (0, _theme.useTheme)();
  var options = (0, _react.useMemo)(function () {
    return accountsToOptions(data, content, theme.highlightColor);
  }, [data, content, theme.highlightColor]);
  var initialValues = (0, _react.useMemo)(function () {
    return options.reduce(function (acc, option) {
      return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, option.key, false));
    }, {});
  }, [options]);
  var checkBoxGroupLabel = (0, _.useTextContent)('accounts.labelYourAccounts');
  var checkBoxGroupHelpText = (0, _.useTextContent)('accounts.textHelp');

  var handleSubmit = function handleSubmit(state) {
    if (Object.keys(state.errors).length) {
      return;
    }

    var accounts = Object.keys(state.values.accounts).reduce(function (acc, key) {
      return state.values.accounts[key] ? [].concat((0, _toConsumableArray2.default)(acc), [parseInt(key, 10)]) : acc;
    }, []);
    onSelectAccounts(accounts);
  };

  if (!options) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_Form.Form, {
    initialValues: {
      accounts: initialValues
    },
    onSubmit: handleSubmit
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_FormLayout.FormLayout, null, /*#__PURE__*/_react.default.createElement(_basis.CheckboxGroup, {
      name: "accounts",
      label: checkBoxGroupLabel,
      options: options,
      helpText: checkBoxGroupHelpText,
      disabled: loading,
      color: theme.inputColor
    }), /*#__PURE__*/_react.default.createElement(_basis.Container, null), /*#__PURE__*/_react.default.createElement(_SubmitButton.SubmitButton, {
      loading: loading
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "accounts.buttonSubmit"
    })));
  });
};

exports.AccountsForm = AccountsForm;